module.exports = __webpack_public_path__ + "static/black-friday-hero-image-48b972e90c44eeef6f5fe8fe0fc432ab.png";